import React from 'react';
import { Button, TopActionBar, ModuleBridge } from '../components';
import { FilePdfOutlined } from '@ant-design/icons';

export const ReportingEntitlementStatus = () => {
    return (
        <>
            <TopActionBar>
                <div>
                    <Button
                        type="primary"
                        icon={<FilePdfOutlined />}
                        className="button button--primary"
                        onClick={() => window.generatePDF()}
                    >
                        Download Entitlements Report
                    </Button>
                </div>
            </TopActionBar>
            <div id="backbone_reporting_wrapper"></div>
            <ModuleBridge moduleId="reporting_entitlement_status_module" />
        </>
    );
};
